export const EVENT: string = 'event';
export const PROFILES: string = 'profiles';
export const SLOT: string = 'slot';
export const MESSAGE: string = 'message';
export const RESERVATION: string = 'reservation';
export const OLD_RESERVATION: string = 'old_reservation';
export const NEW_RESERVATIONS: string = 'new_reservations_uuid';
export const NO_LOGO: string = 'logo';
export const CURRENT_USER: string = 'currentUser';
export const LANG: string = 'lang';

export const DELETABLE_LOCAL_STORAGE_ELEMENTS: Array<string> = [
  EVENT,
  PROFILES,
  SLOT,
  RESERVATION,
  OLD_RESERVATION,
  NEW_RESERVATIONS,
];

export const ALL_LOCAL_STORAGE_ELEMENTS: Array<string> =
  DELETABLE_LOCAL_STORAGE_ELEMENTS.concat(CURRENT_USER);
